export function getBrowserHostname(): string {
    if (typeof window !== "undefined") {
        return window.location.hostname;
    }
    return "";
}

/**
 * Read here rather than through `usePathname` so it also works from
 * `global-error.tsx`, which replaces the root layout and therefore cannot be
 * relied on to sit inside the router context.
 */
export function getBrowserPathname(): string {
    if (typeof window !== "undefined") {
        return window.location.pathname;
    }
    return "";
}

export function getBrowserSearch(): string {
    if (typeof window !== "undefined") {
        return window.location.search;
    }
    return "";
}
